<script>
import { subscriptionFormResource, newsCategoriesListResource } from '@services/common.service.js'
import { djangoToJsBoolean, valueFromSelect } from '@helpers/utils'

export default {
  name: 'news-subscription-controller',
  props: {
    formdata: Object,
  },
  data() {
    return {
      isPrefillForm: djangoToJsBoolean(window.is_auth),
      categoriesList: [],
      lastCategoriesListItem: {
        id: 'all',
        title: this._('Все категории'),
      },
      currentOption: '',
    }
  },
  watch: {
    user: {
      handler(nval) {
        this.formdata = this.fillFormdata(nval)
      },
    },
  },
  mounted() {
    this.getCategories()
  },
  methods: {
    send(data) {
      const copyData = JSON.parse(JSON.stringify(data))
      if (!copyData.category ||
        !copyData.category?.length ||
        0 === copyData.category.length ||
        null === copyData.category[0] ||
        'all' === valueFromSelect(copyData.category[0], 'id')
      ) {
        copyData.isAll = true
        copyData.category = []
      } else {
        copyData.isAll = false
      }
      try {
        copyData.category = valueFromSelect(copyData.category, 'id')
      } catch {
        copyData.category = null
      }
      return subscriptionFormResource.execute({}, copyData)
        .then(res => {
          this.$emit('handle-response', res)
        })
    },
    getCategories() {
      return newsCategoriesListResource.execute()
        .then(({ data: { items } }) => {
          this.categoriesList = items
          this.categoriesList.unshift(this.lastCategoriesListItem)
        })
    },
    handleSelection() {
      let result = []
      if ('all' === this.currentOption) {
        result = this.formdata.category.filter(el => 'all' === el.id)
      } else {
        result = this.formdata.category.filter(el => 'all' !== el.id)
      }
      this.formdata.category = result
    },
    checkCurrentOption(event) {
      this.currentOption = event.id
    },
  },
  render() {
    return this.$scopedSlots.default({
      send: this.send,
      categoriesList: this.categoriesList,
      isLoad: this.isLoad,
      handleSelection: this.handleSelection,
      checkCurrentOption: this.checkCurrentOption,
    })
  },
}
</script>
